import { hydrateImages, debounce, loadStyles } from '@tools/slider_common.js';


function initializeSlickSlider(slider, mode) {
  if (slider.hasClass('slick-initialized')) {
    slider.slick('unslick');
  }

  hydrateImages(slider);

  const isDesktop = mode === 'desktop';

  slider.slick({
    arrows: true,
    centerMode: false,
    centerPadding: '20px',
    slidesToShow: isDesktop ? 4 : 2,
    slidesToScroll: 1,
    infinite: true,
    focusOnSelect: false,
    respondTo: 'window'
  });
}

function applyModeByWidth(slider){
  const w = window.innerWidth;

  if (w <= 768) {
    if (slider.hasClass('slick-initialized')) slider.slick('unslick');
    initializeSlickSlider(slider, 'mobile');
  }

  if (w > 768) {
    if (slider.hasClass('slick-initialized')) slider.slick('unslick');
    initializeSlickSlider(slider, 'desktop');
  }
}

function instagramSliderHandler() {
  let slickSliderScript = document.querySelector('script[src="/static/slick-slider/slick.min.js"]');

  if (slickSliderScript) {
    const slider = $('.instagram-slider-body');
    applyModeByWidth(slider);

    $(window).on('resize', debounce(function(){
      applyModeByWidth(slider);
    }, 120));
  } else {
    loadStyles(['slick.css', 'slick-theme.css'], '/static/slick-slider/');
    slickSliderScript = document.createElement('script');
    slickSliderScript.src = '/static/slick-slider/slick.min.js';
    document.body.appendChild(slickSliderScript);

    slickSliderScript.onload = function () {
      const slider = $('.instagram-slider-body');
      applyModeByWidth(slider);

      $(window).on('resize', debounce(function(){
        applyModeByWidth(slider);
      }, 120));
    }
  }

}

export function instagramSliderObserver() {
  const instagramSlider = document.querySelector('.instagram-slider-body');

  if (instagramSlider) {
    const instagramSliderObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          instagramSliderHandler();
          instagramSliderObserver.disconnect();
        }
      });
    });
    instagramSliderObserver.observe(instagramSlider);
  }
}
